import Template from "../templates/EditSubjectDID/EditSubjectDIDTemplate";

const EditSubjectDID = () => <Template />;

export default EditSubjectDID;
